import type { Vec2 } from './types'

export const TRACK_WORLD_SCALE = 1.2
export const TRACK_WIDTH = 24

const BASE_TRACK_CONTROL_POINTS: readonly Vec2[] = [
  { x: -150, y: -110 },
  { x: -65, y: -110 },
  { x: 30, y: -110 },
  { x: 125, y: -104 },
  { x: 160, y: -70 },
  { x: 150, y: -15 },
  { x: 112, y: 25 },
  { x: 65, y: 30 },
  { x: 35, y: 85 },
  { x: -5, y: 110 },
  { x: -30, y: 72 },
  { x: -10, y: 38 },
  { x: -55, y: 24 },
  { x: -105, y: 65 },
  { x: -160, y: 40 },
  { x: -145, y: -25 },
]

export const TRACK_CONTROL_POINTS: readonly Vec2[] = BASE_TRACK_CONTROL_POINTS.map((point) => ({
  x: point.x * TRACK_WORLD_SCALE,
  y: point.y * TRACK_WORLD_SCALE,
}))

export const TRACK_SAMPLE_COUNT = 384
export const TRACK_CHECKPOINT_COUNT = 16
